<div class="p-6">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-xl font-bold text-gray-900 dark:text-white">
      {{ isEditMode ? 'Edytuj plan' : 'Nowy plan subskrypcji' }}
    </h2>
    <button mat-icon-button (click)="close()">
      <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="space-y-4">

      <!-- Typ i Nazwa -->
      <div class="grid grid-cols-2 gap-4">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Stage</mat-label>
          <mat-select formControlName="stage">
            <mat-option *ngFor="let stage of planStages" [value]="stage">
              {{ stage }}
            </mat-option>
          </mat-select>
          <mat-icon matPrefix [svgIcon]="'tabler_outline:category'"></mat-icon>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Nazwa planu</mat-label>
          <input matInput formControlName="name" placeholder="np. Start Roczny">
          <mat-icon matPrefix [svgIcon]="'tabler_outline:tag'"></mat-icon>
        </mat-form-field>
      </div>

      <!-- Opis -->
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Opis</mat-label>
        <textarea matInput formControlName="description" rows="2" placeholder="Opis planu..."></textarea>
        <mat-icon matPrefix [svgIcon]="'tabler_outline:file-text'"></mat-icon>
      </mat-form-field>

      <!-- Ceny -->
      <div class="grid grid-cols-3 gap-4">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Cena (PLN)</mat-label>
          <input matInput type="number" formControlName="price" min="0" step="0.01">
          <mat-icon matPrefix [svgIcon]="'tabler_outline:currency-zloty'"></mat-icon>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Cena przed rabatem</mat-label>
          <input matInput type="number" formControlName="originalPrice" min="0" step="0.01" placeholder="Opcjonalnie">
          <mat-icon matPrefix [svgIcon]="'tabler_outline:currency-zloty'"></mat-icon>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Rabat (%)</mat-label>
          <input matInput type="number" formControlName="discountPercent">
          <mat-icon matPrefix [svgIcon]="'tabler_outline:tag'"></mat-icon>
          <mat-hint>Wyliczany automatycznie</mat-hint>
        </mat-form-field>
      </div>

      <!-- Okres trwania -->
      <div class="grid grid-cols-2 gap-4">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Okres (miesiące)</mat-label>
          <input matInput type="number" formControlName="durationMonths" min="1">
          <mat-icon matPrefix [svgIcon]="'tabler_outline:calendar'"></mat-icon>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Limit dokumentów / miesiąc</mat-label>
          <input matInput type="number" formControlName="invoiceLimit" min="0" placeholder="Bez limitu">
          <mat-icon matPrefix [svgIcon]="'tabler_outline:file-invoice'"></mat-icon>
          <mat-hint>Puste = bez limitu</mat-hint>
        </mat-form-field>
      </div>

      <!-- Status -->
      <div class="flex items-center gap-4 py-2">
        <mat-slide-toggle formControlName="isActive" color="primary">
          Plan aktywny
        </mat-slide-toggle>
        <span class="text-sm text-gray-500 dark:text-gray-400">
          Tylko aktywne plany są widoczne dla użytkowników
        </span>
      </div>

    </div>

    <!-- Actions -->
    <div class="flex items-center gap-3 mt-6 pt-4 border-t dark:border-gray-700">
      <button 
        *ngIf="isEditMode"
        mat-button
        type="button"
        color="warn"
        (click)="deletePlan()"
        [disabled]="isSaving || isDeleting">
        <mat-spinner *ngIf="isDeleting" diameter="18" class="mr-2"></mat-spinner>
        <mat-icon *ngIf="!isDeleting" [svgIcon]="'tabler_outline:trash'" class="icon-size-5 mr-1"></mat-icon>
        Usuń plan
      </button>
      <div class="flex-1"></div>
      <button 
        mat-button 
        type="button"
        (click)="close()"
        [disabled]="isSaving || isDeleting">
        Anuluj
      </button>
      <button 
        mat-raised-button 
        color="primary"
        type="submit"
        [disabled]="form.invalid || isSaving"
        class="!rounded-lg">
        <mat-spinner *ngIf="isSaving" diameter="20" class="mr-2"></mat-spinner>
        {{ isEditMode ? 'Zapisz zmiany' : 'Utwórz plan' }}
      </button>
    </div>
  </form>
</div>
